// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { Link } from '@iheartjane/reefer';

export const StyledLink = styled(Link)({
  display: 'inline',
});
